import React from 'react';
import { Virtuoso } from 'react-virtuoso';
import moment from 'moment';

import { Spinner } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';

import { getSelectLabel, lang, userFullName, scssVariables, permissions } from 'src/helpers';

import constants from 'src/constants';
import AppointmentStatus from './AppointmentStatus';
import { Link } from 'react-router-dom';

class AppointmentList extends BaseComponent {
  componentDidMount() {
    this.props.model.subscribe(this.subscription);
  }

  componentWillUnmount() {
    this.props.model.unsubscribe(this.subscription);
  }

  render() {
    let { model } = this.props;
    const items = model.items();
    const loading = model.refreshing();
    let searchQuery = model.listInput('search');
    let noResults = model.noResults();
    const columns = [
      {
        label: 'Date and time',
        cellStyles: { minWidth: 200 },
        render: (item) =>
          item.data?.startDate ? moment(item.data.startDate).format('DD MMM YYYY hh:mm a') : ''
      },
      {
        label: 'Type',
        cellStyles: { minWidth: 80 },
        render: (item) =>
          getSelectLabel(constants.general.appointment_types, item.data.appointmentType)
      },
      {
        label: 'Doctor',
        render: (item) => (item.partner?.isDoctor ? 'Dr. ' : '') + userFullName(item.partner)
      },
      {
        label: 'Status',
        cellStyles: { maxWidth: 150 },
        render: (item) => <AppointmentStatus appointment={item} />
      },
      {
        label: 'Actions',
        cellStyles: { textAlign: 'center' },
        render: (item) => (
          <Link
            className={'mc-no-style-btn'}
            to={permissions.PAGES.APPOINTMENTS_DETAIL_PAGE.match(item.id)}
          >
            <SVGIcon
              iconname={BASE_ICONS.EYE_FILL}
              fill={scssVariables['colors-mc-primary']}
              fillOpacity={'0.5'}
              width={42}
              dark
              padding={5}
              radius
            />
          </Link>
        )
      }
    ];

    return (
      <div className={'mc-appointment mc-flex-col mc-grow'}>
        <div className={'mc-table-basic template-3'}>
          <div className={'mc-table-header'}>
            {columns.map((item, i) => (
              <div key={'mc-table-th-' + i} className={'mc-cell'} style={item.cellStyles || {}}>
                {lang.t(item.label)}
              </div>
            ))}
          </div>
          <div className={'mc-table-body mc-grow'}>
            <Virtuoso
              data={items}
              components={{
                Footer: () => (
                  <>
                    {(noResults || loading) && (
                      <div style={{ textAlign: 'center', padding: '1rem' }}>
                        {noResults && !searchQuery && <div>{lang.t('No results yet')}</div>}
                        {noResults && searchQuery && <div>{lang.t('Nothing found')}</div>}
                        {loading && <Spinner />}
                      </div>
                    )}
                  </>
                )
              }}
              endReached={() => {
                if (model.hasMore() && !model.refreshing()) model.loadMore();
              }}
              itemContent={(i, item) => (
                <div
                  data-testid='table-row'
                  key={'mc-table-item-' + (item.id + '-' + i)}
                  className={'mc-row ' + (i % 2 === 1 ? 'mc-even' : 'mc-odd')}
                >
                  {columns.map((col, j) => (
                    <div
                      key={'mc-table-item-' + item.id + '-' + j}
                      className={'mc-cell'}
                      style={col.cellStyles || {}}
                    >
                      {col.render(item, i)}
                    </div>
                  ))}
                </div>
              )}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default AppointmentList;
